module.exports = __webpack_public_path__ + "static/media/untitled.6a4f9c31.svg";